// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__wBHxb","productName":"Table_productName__38f93"};